/**
 * D-068: FM-0012 "Assembly Traceability Record" (OSIUK-W-FM-0012, Revision 3) formunun basılı satırları ve montaj kaydının
 * sözlükleri. `fm11.ts`'in eşidir, ama alan paketindedir: sunucu (okuyucu, yazım) ve tarayıcı (Assembly sayfası) aynı sabiti okur.
 *
 * Formda satır numarası basılı DEĞİLDİR; `no` üç form okumasının ortak sayımıdır ve sözleşmedir (assembly-input-sozlesmesi.md
 * PARTS `#`). Satırın çapası `no` + `osiPn`'dir: aynı satır basıma göre başka sayfada ve başka dikey konumda durur.
 * `ad` formdaki basılı metindir, yazım hatasıyla birlikte aynen ("BOUYANCY MODULE"); düzeltilmez.
 *
 * Aynı form numarası ve revizyon altında ÜÇ basım vardır (revizyon değişmeden içerik değişmiş):
 * - A: 29 satır (30. satır yok); sayfa sayacı "Page x of 2"; değer sütunu başlığı "PO No. / Cert. No. / Serial No.";
 *      box gap için basılı satır yok; sayfalar 1–8 · 9–20 · 21–29.
 * - B: 30 satır; "Page x of 2"; başlıkta "… / Torque value"; box gap satırları basılı ("Box Float dimension"); sayfalar 1–7 · 8–20 · 21–30.
 * - C: B ile aynı satırlar; "Page x of 4"; box satırlarında "Box Gap:" basılı; Max. Working Pressure basılı.
 * Basım form numarasından değil sayfanın kendisinden anlaşılır ve kayıtta tutulur (`montaj_kaydi.basim`).
 */
export const FM12_BASIMLARI = ["A", "B", "C"];
export const fm12BasimiMi = (b) => FM12_BASIMLARI.includes(b);
const ABC = FM12_BASIMLARI;
const BC = ["B", "C"];
const satir = (no, ad, oemPn, osiPn, qty, ek = {}) => ({ no, ad, oemPn, osiPn, qty, basimlar: ABC, fm11: null, liste: false, hat: null, ...ek });
export const FM12_SATIRLARI = [
    satir(1, "MAIN BARREL", "H139311-10H935", "56026001121", 1),
    satir(2, "PIN INSERT", "H240540-4", "56026001009", 1, { fm11: 7 }),
    satir(3, "CHOKE & KILL LINE", "H122780-1H935", "56026001126", 2, { fm11: 13, hat: "CK" }),
    satir(4, "BOOSTER LINE", "H122782-1H935", "56026001128", 1, { fm11: 14, hat: "B" }),
    satir(5, "HYDRAULIC LINE", "H122781-3H935", "56026001130", 1, { fm11: 15, hat: "H" }),
    satir(6, "C&K ADJUSTMENT SLEEVES (Locknut)", "R126200-32", "56026001017", 2, { fm11: 9, hat: "CK" }),
    satir(7, "BOOSTER LINE, ADJUSTMENT SLEEVE (Locknut)", "H171688-1", "56026001033", 1, { fm11: 10, hat: "B" }),
    satir(8, "HYDRAULIC LINE, ADJUSTMENT SLEEVE (Locknut)", "H171688-2", "56026001034", 1, { fm11: 11, hat: "H" }),
    satir(9, "LOCKING BOLTS", "H141522-2", "56026001013", 6, { fm11: 4, liste: true }),
    satir(10, "LOCK BOLT WASHER", "H12273-4", "56026001015", 6, { fm11: 5, liste: true }),
    satir(11, "LOCKING INSERT", "H141521-2", "56026001011", 6, { fm11: 3, liste: true }),
    satir(12, "CLAMP ASSEMBLY", null, "56026001191", 5),
    satir(13, "DEFLECTOR SEGMENT, PIN END", null, "56026001045", 2),
    satir(14, "DEFLECTOR SEGMENT, BOX END", null, "56026001043", 2),
    satir(15, "LOCATING PIN", "06047901", "56026001087", 1),
    satir(16, "FIXED THRUST COLUMN, HYDRAULIC LINE, BOX END", "H196148-1", "56026001194", 1),
    satir(17, "ADJUSTABLE THRUST COLUMN, HYDRAULIC LINE, PIN END", "H196221-1", "56026001195", 1),
    satir(18, "FIXED THRUST COLUMN, BOOSTER LINE, BOX END", "H196149-1", "56026001196", 1),
    satir(19, "ADJUSTABLE THRUST COLUMN, BOOSTER LINE, PIN END", "H196222-1", "56026001197", 1),
    satir(20, 'O-RING IMPERIAL, 20.0" ID x 0.210" CS, 90 DURO', null, "92001009017", 1),
    satir(21, 'O-RING IMPERIAL, 20.0" ID x 0.437" CS, 90 DURO', null, "92001009016", 3),
    satir(22, "POLYPAK IMPERIAL, 4615-25006000-375B (C&K Lines)", null, "92005002102", 4),
    satir(23, "POLYPAK IMPERIAL, 4615-25003375-375B (Hydraulic line)", null, "92005002103", 2),
    satir(24, "POLYPAK IMPERIAL, 4615-25004250-375B (booster line)", null, "92005002104", 2),
    satir(25, "RETAINING RING, 4.125OD x 3.38ID x 0.142TK (Bolt and Washer)", "H225107-2", "94018000016", 6),
    satir(26, "RETAINING RING, 4.756 ID x 0.111 THK (Locking Insert)", "199853-132", "94018002012", 6),
    satir(27, '1/2"-12 UNC x 0.5" LG, SET SCREW', "6501027500", "91015005007", 16),
    satir(28, "HAMMER DRIVE SCREW, No.2, 0.25 LG, ROUND HEAD, DRIVE U, A2 STAINLESS STEEL", null, "91040001001", 4),
    satir(29, "DETAIL MDR RISER IDENTIFICATION PLATE", null, "56000004001", 1),
    satir(30, "BOUYANCY MODULE", null, null, null, { basimlar: BC, fm11: 1, liste: true }),
];
/** Formun satırı; `no` 1–30 dışında ya da tam sayı değilse null. */
export const fm12Satiri = (no) => (Number.isInteger(no) ? (FM12_SATIRLARI[no - 1] ?? null) : null);
/** Basımın parça satırı sayısı: A = 29, B ve C = 30. Basım bilinmiyorsa 30 (en geniş basım). */
export const fm12SatirSayisi = (basim) => (basim === "A" ? 29 : 30);
/** Satır bu basımda basılı mı (30. satır A basımında basılı değildir). */
export const fm12Basili = (no, basim) => no >= 1 && no <= fm12SatirSayisi(basim);
/** Parça tablosunun sayfalara dağılımı: [ilk satır, son satır], sırasıyla 1., 2. ve 3. sayfa. 4. sayfada parça satırı yoktur. */
export const FM12_SAYFA_ARALIKLARI = {
    A: [[1, 8], [9, 20], [21, 29]],
    B: [[1, 7], [8, 20], [21, 30]],
    C: [[1, 7], [8, 20], [21, 30]],
};
/** Basımın verilen sayfasındaki satır numaraları (sayfa 1–3); başka sayfa için boş dizi. Eksik taranmış sayfanın satırlarını söyler. */
export function fm12SayfaSatirlari(basim, sayfa) {
    const a = FM12_SAYFA_ARALIKLARI[basim][sayfa - 1];
    return a ? Array.from({ length: a[1] - a[0] + 1 }, (_, i) => a[0] + i) : [];
}
/** B ve C basımlarında satır adının altındaki italik not (A basımında yok). */
export const FM12_ALT_NOTLAR = {
    13: "(Only required for Slick Joints)",
    14: "(Only required for Slick Joints)",
    20: "(Not to be installed during assembly in yard)",
    21: "(Not to be installed during assembly in yard)",
    22: "(Not to be installed during assembly in yard)",
    23: "(Not to be installed during assembly in yard)",
    24: "(Not to be installed during assembly in yard)",
};
/** Satır durumu; saklanan değerler kalıcıdır (S4). Boş (null) = hücre boş ya da okunamadı. */
export const MONTAJ_SATIR_DURUMLARI = ["takildi", "listede", "sahada", "takilmadi", "uygulanmaz"];
/**
 * Durumun sözleşmedeki İngilizce sözü (PARTS `status`); ekranda da bu söz gösterilir. Durum sözlüğünün TEK kaynağıdır:
 * okuyucunun durum haritası ve web'deki satır durumu etiketi bundan türetilir, ikinci bir tanım yazılmaz.
 */
export const MONTAJ_DURUM_SOZU = {
    takildi: "fitted",
    listede: "see list",
    sahada: "fit on rig",
    takilmadi: "not fitted",
    uygulanmaz: "not applicable",
};
/**
 * Hücrede iki söz birden yazılmışsa kazanan durumun sırası (sözleşme §3.3): hücrede kimlik (takildi) > NOT FITTED > FIT ON RIG >
 * SEE BACK > N/A. Fiziksel durumu söyleyen söz, yalnız yönlendiren sözden önce gelir.
 * Motorun satır durumu kuralının (Yöntem §4.4) depodaki belgesi ve testi; çağıranı yoktur.
 */
export const MONTAJ_DURUM_ONCELIGI = ["takildi", "takilmadi", "sahada", "listede", "uygulanmaz"];
/**
 * Aday durumlardan önceliği en yüksek olan; aday yoksa null.
 * Motorun satır durumu kuralının (Yöntem §4.4) depodaki belgesi ve testi; çağıranı yoktur.
 */
export const montajDurumSec = (adaylar) => MONTAJ_DURUM_ONCELIGI.find((d) => adaylar.includes(d)) ?? null;
export const MONTAJ_OLCUM_TIPLERI = ["stickout", "gap"];
/** Söküm ölçümüyle (`sokum_olcum.hat`) aynı kodlar ve aynı sıra. */
export const MONTAJ_OLCUM_HATLARI = ["CH", "KL", "BST", "HYD"];
/**
 * Kaba akla yatkınlık aralığı, inç (mm için ×25.4). Amaç ondalık noktası ya da birim kaybını yakalamaktır (3.807 → 38.07;
 * 0.821 → 8.21; 3.5 in → 88.9 mm); tolerans yargısı DEĞİLDİR (K-V4). Arşivde okunan değerler: stick-out 3.000–4.257,
 * box gap 0.674–0.877.
 */
export const MONTAJ_OLCU_ARALIGI = { stickout: [1.0, 8.0], gap: [0.2, 2.5] };
//# sourceMappingURL=fm12.js.map